import { ReactNode } from "react";

type VociDataEntryProps = {
  label: string;
  children: ReactNode;
};

export function VociDataEntry({ children, label }: VociDataEntryProps) {
  return (
    <div className="flex flex-row justify-between items-center text-base">
      <div className="text-font-secondary">{label}:</div>
      <div className="font-medium">{children}</div>
    </div>
  );
}
